module.exports = __webpack_public_path__ + "static/pr-7008-12e796a08a1745838305740da6a80cef.png";